import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom'
import axios from "../../axios"
import "./EditProduct.css"
import swal from 'sweetalert'
import ImageKit from 'imagekit-javascript';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import HomeIcon from '@mui/icons-material/Home';

const EditProduct = () => {
  const [title,setTitle]=useState('')
  const [price,setPrice]=useState(0)
  const [tags,setTags]=useState([])
  const [image,setImage]=useState('')
  const [stock,setStock]=useState('')
  const [brand,setBrand]=useState('')
  const [category,setCategory]=useState('')
  const [newTag,setNewTag]=useState('')
  const [active,setActive]=useState(true)
  const [reset,setReset]=useState(1)
  const params=useParams()
  const [imgUrlorfile,setimgUrlorFile]=useState(true)
  const [imgFile,setImgFile]=useState(undefined)
  const [localImgFile,setLocalImgFile]=useState(undefined)
  const [processing,setProcessing]=useState(false)
  const [prevFileId,setPrevFileId]=useState(undefined)
  const imgFileRef=useRef()
  const [loading,setLoading]=useState(false)

  useEffect(()=>{
    if(imgUrlorfile){
      setImgFile(undefined)
      setLocalImgFile(undefined)
      imgFileRef.current.value=""
    }
  },[imgUrlorfile])
  useEffect(()=>{
    setLoading(true)
    axios({
      method: 'get',
      url: `/products/${params.id}`
    }).then(res => { 
      setTags(res.data.product.tags);
      setTitle(res.data.product.title)
      setPrice(res.data.product.price)
      setImage(res.data.product.image)
      setStock(res.data.product.stock)
      setBrand(res.data.product.brand)
      setCategory(res.data.product.category)
      setPrevFileId(res.data.product.fileId)
      setActive(res.data.product.active)
      setLoading(false)
    })
    .catch(err => {console.log(err);setLoading(false)})
  },[reset,imgFile,imgUrlorfile])
  const data={
    title,
    price,
    tags,
    image,
    stock,
    brand,
    category,
    fileId:undefined,
    prevFileId,
    active
  }

  const getAuthParams = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URI}/imagekit-auth`);
      const data = await response.json();
      return data;
    } catch (error) {
      swal("","file auth error","error")
      console.error('Error fetching authentication parameters:', error);
      setProcessing(false)
      return null;
    }
  };
  const update=async()=>{
    setProcessing(true)
    if(imgFile){
      const authParams = await getAuthParams();
      if(authParams){
        const { token, signature, expire } = authParams;
        const imageKit = new ImageKit({
          publicKey: process.env.REACT_APP_IMAGEKIT_PK,
          urlEndpoint: process.env.REACT_APP_IMAGEKIT_URI_ENDPOINT,
          authenticationEndpoint: `${process.env.REACT_APP_SERVER_URI}/file/upload`
        });
        imageKit.upload({
          file:imgFile[0],
          fileName:imgFile[0].name,
          signature: signature,
          token: token,
          expire: expire,
          folder:'/skgrocery/products'
        })
        .then(res=>{
          axios({
            method: 'post',
            url: `/products/update/${params.id}`,
            data:{...data,image:res.url,fileId:res.fileId,prevFileId}
        }).then(res => {
          swal("","Product Updated","success")
          setProcessing(false)
        }).catch(err => console.log(err))
        })
      }
    }else if(imgFile===undefined){
      axios({
        method: 'post',
        url: `/products/update/${params.id}`,
        data:data
    }).then(res =>{
      swal("","Product Updated","success")
      setProcessing(false)
    })
    .catch(err => console.log(err))
    }
  }
  const removeTag=(t)=>{
    setTags(tags.filter(tags=>tags!=t))
  }
  const addTag=()=>{
    setTags([...tags,newTag])
    setNewTag('')
  }

  const handleImgFile=(e)=>{
    try{
      if (e.target.files && e.target.files[0]) {
        setLocalImgFile(URL.createObjectURL(e.target.files[0]));
        setImgFile(e.target.files)
      }
    }catch(e){
      console.log(e)
    }

  }
  return (
    <div className='edit__product__main'>
      <div className='edit__product__action mb-2 mt-2'>
      <Link to='/admin'><HomeIcon fontSize='large'/></Link>
      {loading?
      <RestartAltIcon className='RestartAltIcon' fontSize='large'/>
      :
      <RestartAltIcon fontSize='large' onClick={()=>{setReset(!reset);setLocalImgFile(undefined);imgFileRef.current.value=''}}/>
      }
      </div>
      <div className='edit__product__container mb-4'>
        <div className='row'>
        <div className='col-sm-12 col-md-7'>
        Title: <input style={{width:"80%"}} onChange={(e)=>setTitle(e.target.value)} type='text' value={title}/>
        </div>
        <div className='col-sm-12 col-md-4 mt-3 mt-md-0'>
          Price : <input  style={{width:'80px'}} type='text' value={price} onChange={(e)=>setPrice(e.target.value)}/>
        </div>
        </div>
        <div className='row justify-content-center mt-3 mb-4'>
          <div className='p-4 col-md-6 col-12 d-flex justify-content-center' style={{backgroundColor:`${image===''&&imgFile===undefined?'#cccccc':''}`,minHeight:'200px',borderRadius:'20px'}}>
            <img width='300px' src={localImgFile?localImgFile:image}/>
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-md-8'>
            {imgUrlorfile?'Image URL :':'Image File :'}
            <label className="switch ml-2">
              <input type="checkbox" onChange={() => { setimgUrlorFile(!imgUrlorfile) }} />
              <span className="slider round"></span>
            </label>
            <input disabled={!imgUrlorfile} className='ml-2 mr-3' type='text' value={image} onChange={(e) => setImage(e.target.value)} placeholder='image url' />
            <input className='mt-3 mt-md-0' ref={imgFileRef} disabled={imgUrlorfile} type='file' multiple onChange={handleImgFile} />
          </div>
          <div className='col-md-4 mt-3 mt-md-0'>
            {active?'Active':'Inactive'} :
            <label className="switch ml-2">
              <input type="checkbox" onChange={() => { setActive(!active) }} checked={active}/>
              <span className="slider round"></span>
            </label>
          </div>
        </div>
       <div className='row mt-3'>
       <div className='col-4'>
          Category : <input type='text' style={{width:'80%'}}  value={category} onChange={(e)=>setCategory(e.target.value)}/>
        </div>
        <div className='col-4'>
          Stock : <input type='number' style={{width:'80%'}}  value={stock?stock:0} onChange={(e)=>setStock(e.target.value)}/>
        </div>
        <div className='col-4'>
          Brand : <input type='text'  style={{width:'80%'}} value={brand} onChange={(e)=>setBrand(e.target.value)}/>
        </div>
       </div>
        <div className='row mt-3'>
        <div className='col'>
          Tags : {tags&&tags.map((t,i) => 
          <span key={i}>
          <span style={{fontSize:'15px'}}className='mr-2 mt-2 mb-2 badge badge-pill  badge-success'>{t} <button className='edit__product__tags__remove' onClick={()=>removeTag(t)}>x</button></span>
          </span>)}
          <br></br>
          <input onChange={(e)=>setNewTag(e.target.value)} value={newTag} type='text'/><button className='ml-2' onClick={addTag}>add tag</button>
        </div>
      </div>
      <button style={{width:'70px'}} disabled={processing} onClick={update}>{processing?
        <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
          :
        'Update'}</button>
      </div>
     
      
 
    </div>
  )
}

export default EditProduct
